import type { IBandAxisTheme } from '@visactor/vchart';

export const axisBand: IBandAxisTheme = {
  domainLine: {
    visible: true
  },
  grid: {
    visible: false
  },
  subGrid: {
    visible: false
  },
  tick: {
    visible: false
  },
  subTick: {
    visible: false
  }
};
